import React, { useEffect, useState, useRef } from "react";
import "echarts-gl";
import * as echarts from 'echarts';
import PageHeader from "../../components/PageHeader.js";
import {getLastSession,getLastUser,getDashboardInfo,setDashboardInfo,getCurrentDeviceSerial,setCurrentDeviceSerial} from '../../Data/SessionData.js';
import { createSession, loginUser, dashboardData } from '../../RestUtil.js';
import { chartOption3, chartOption4 } from "../../Data/DemographicData.js";
import SwitchBordCard from "../../components/SwitchBordCard.js";

export default function MRStatus(props) {

  const timer = 0;
  const [graphMode, setGraphMode] = useState("Live");    
  const [sessionInfo, setSessionInfo] = useState(null);    
  const [timerId, setTimerId] = useState(0);    
  const [timerList, setTimerList] = useState([]);    
  const [dashData1, setDashData1] = useState(null);    
  const [buttonsIndoor, setButtonsIndoor] = useState([{title: "BRAKE STATUS",switch: false,}]);
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [deviceSerial, setDeviceSerial] = useState("");
  const [currDeviceSerial, setCurrDeviceSerial] = useState(getCurrentDeviceSerial);

  useEffect(() => {
    setSessionInfo( getLastSession() );
    var profileData = getLastUser();
    if (profileData != null) {
        setDeviceSerial(profileData.deviceSerial);
    }
    var dashData2 = getDashboardInfo();
    console.log("BE Data from MRStatus", dashData2);
    setDashData1( dashData2 );
  }, []);

  useEffect(() => {
    if (timerId <= 0) return;
    console.log("timer item being newly added  = ",timerId);
    timerList.push(timerId);
    console.log("timer List after push = ",timerList);
    if (timerList.length > 1) {
       var itemToDelete = timerList.shift();
       console.log("timer List after shift = ",timerList);
       console.log("timer shifted item = ",itemToDelete);
       if (itemToDelete !== timerId) {
          clearInterval(itemToDelete);
          console.log("Now cleared timer with id ",itemToDelete);
       }
    }
    // console.log("timer Item newly added "+timerId+" being deleted "+itemToDelete);
  }, [timerId]);

  const deviceSerialChanged = (newSerial) => {
    console.log("Device Serial changed detected3 in Dashboard",newSerial);
    setCurrentDeviceSerial(newSerial);
    setCurrDeviceSerial(newSerial);
    setTimerToPullBEData(newSerial);
  }

  function setTimerToPullBEData(newSerial) {
    const intervalId = setInterval(() => {
      console.log("MRStatus timer-id = "+intervalId,"refreshing every seconds");
      pullBEData('Live',newSerial);
    }, 3000); // Update every 3 seconds
    setTimerId(intervalId);
    console.log("Set new timer with id",intervalId);
  }

  function pullBEData(modeStr,newSerial) {
    var sessionData = getLastSession();
    console.log("Last Session",sessionData);
    dashboardData(sessionData.id,modeStr,newSerial).then(resp => {
      console.log("dashboard resp",resp);
      setDashboardInfo(resp);
      var dashData2 = getDashboardInfo();
      console.log("pullBEData", dashData2);
      setDashData1( dashData2 );  
    })
    .catch(err2 => {
      console.log("dashboard failed",err2);          
    });
  }

  useEffect(() => {
    if (dashData1 == null) return;
    var temp1 = [...buttonsIndoor];
    temp1[0].switch = (dashData1.brakeStatus === "OPEN");
    console.log("Brake Status from BE",dashData1.brakeStatus);
    setButtonsIndoor(temp1);
    chartPlace();
  }, [dashData1])

  function deleteLastTimer() {
    if (timerList.length > 0) {
        var itemToDelete = timerList.shift();
        console.log("timer List after shift = ",timerList);
        console.log("timer shifted item = ",itemToDelete);
        if (itemToDelete > 0) {
          clearInterval(itemToDelete);
          console.log("Now cleared timer with id ",itemToDelete);
        }
    }
  }

  useEffect(() => {
    if (graphMode == null) return;
    console.log("Graph Mode is changed to",graphMode);
    if (graphMode === "Live") {
        console.log("Now setting-up timer again");
        setTimerToPullBEData(currDeviceSerial);
    }
    else
    if (graphMode === "Weekly") {
      deleteLastTimer();
      setTimerId(0);
      pullBEData(graphMode,currDeviceSerial);
    }
    else
    if (graphMode === "Days15") {
      deleteLastTimer();
      setTimerId(0);
      pullBEData(graphMode,currDeviceSerial);
    }
    else
    if (graphMode === "Days30") {
      deleteLastTimer();
      setTimerId(0);
      pullBEData(graphMode,currDeviceSerial);
    }
  }, [graphMode]);

  function chartPlace() {
    var chartDom = document.getElementById("m_area_chart");
    var myChart = echarts.init(chartDom);
    var option;
    const colors = ['blue', 'red', 'green'];
    option = chartOption3; // genderOverViewOption;
    console.log("dashData1.mrTempXaxis",dashData1.mrTempXaxis);
    if (option != null && option.xAxis != null && option.xAxis.length && dashData1.mrTempXaxis && dashData1.mrTempXaxis.length) {
       option.xAxis[0].data = dashData1.mrTempXaxis;
       if (option.xAxis.length > 1) {
          option.xAxis[1].data = dashData1.mrTempXaxis;
       }       
    }
    if (option != null && option.series != null && option.series.length) {
       console.log("brakeTemps",dashData1.latestBrakeTemps);
       console.log("motorTemps",dashData1.latestMotorTemps);
       option.series[0].data = dashData1.latestBrakeTemps;
       if (option.series.length > 1) {
          option.series[1].data = dashData1.latestMotorTemps;
       }
    }
    if (dashData1.latestMRBMETemp) {
      option.xAxis.push(    {
        type: 'category',
        axisTick: {
          alignWithLabel: true
        },
        axisLine: {
          onZero: false,
          lineStyle: {
            color: colors[2]
          }
        },
        axisPointer: {
          label: {
            formatter: function (params) {
              return (
                'MR Temp  ' +
                params.value +
                (params.seriesData.length ? '：' + params.seriesData[0].data : '')
              );
            }          
          }
        },
        data: []
      }
      );
      option.series.push({
        name: 'MR Temp',
        type: 'line',
        xAxisIndex: 2,
        smooth: true,
        emphasis: {
          focus: 'series'
        },
        data: []
      });
      console.log("latestBrakeTemps",dashData1.latestMRBMETemp);
      option.series[2].data = dashData1.latestMRBMETemp;
    }
    option && myChart.setOption(option);
    //
    // Chart #2 - MR Pressure
    //
    var chartDom2 = document.getElementById("m_area_chart2");
    var myChart2 = echarts.init(chartDom2);
    var option2;
    option2 = chartOption4;
    console.log("dashData1.mrPressureXaxis",dashData1.mrPressureXaxis);
    if (option2 != null && option2.xAxis != null && option2.xAxis.length && dashData1.mrPressureXaxis && dashData1.mrPressureXaxis.length) {
       option2.xAxis[0].data = dashData1.mrPressureXaxis;
    }
    if (option2 != null && option2.series != null && option2.series.length) {
       option2.series[0].data = dashData1.latestMRBmePerssure;
       option2.series[0].name = "Machine Room Pressure";
       option2.xAxis[0].axisPointer.label.formatter = function (params) {
        return (
          'Pressure ' +
          params.value +
          (params.seriesData.length ? '：' + params.seriesData[0].data : '')
        );
      };
    }
    option2 && myChart2.setOption(option2);
    //
    // Chart #3 - Elevator Humidity
    //
    var chartDom3 = document.getElementById("m_area_chart3");
    var myChart3 = echarts.init(chartDom3);
    var option3;
    option3 = chartOption4;
    console.log("dashData1.mrHumidityXaxis",dashData1.mrHumidityXaxis);
    if (option3 != null && option3.xAxis != null && option3.xAxis.length && dashData1.mrHumidityXaxis && dashData1.mrHumidityXaxis.length) {
       option3.xAxis[0].data = dashData1.mrHumidityXaxis;
    }
    if (option3 != null && option3.series != null && option3.series.length) {
       option3.series[0].data = dashData1.latestMRBmeHumidity;
       option3.series[0].name = "MR Humidity";
       option3.xAxis[0].axisPointer.label.formatter = function (params) {
        return (
          'Humidity ' +
          params.value +
          (params.seriesData.length ? '：' + params.seriesData[0].data : '')
        );
      };
    }
    option3 && myChart3.setOption(option3);
    //
    // Chart #4 - Elevator ADXLXYZ
    //
    var chartDom4 = document.getElementById("m_area_chart4");
    var myChart4 = echarts.init(chartDom4);
    var option4;
    option4 = chartOption4;
    console.log("dashData1.mrAdxLxyzXaxis",dashData1.mrAdxLxyzXaxis);
    if (option4 != null && option4.xAxis != null && option4.xAxis.length && dashData1.mrAdxLxyzXaxis && dashData1.mrAdxLxyzXaxis.length) {
       option4.xAxis[0].data = dashData1.mrAdxLxyzXaxis;
    }
    if (option4 != null && option4.series != null && option4.series.length) {
       option4.series[0].data = dashData1.latestMRAdxlxyz;
       option4.series[0].name = "Building Vibration";
       option4.xAxis[0].axisPointer.label.formatter = function (params) {
        return (
          'Vibration ' +
          params.value +
          (params.seriesData.length ? '：' + params.seriesData[0].data : '')
        );
      };
    }
    option4 && myChart4.setOption(option4);
  };

  function handleGraphModeChange(newMode) {
    console.log("handleGraphModeChange", newMode);
    setGraphMode(newMode);
  }

    return (
      <div
        style={{ flex: 1 }}
        onClick={() => {
          document.body.classList.remove("offcanvas-active");
        }}
      >
        <div>
          <div className="container-fluid">
            {dashData1 && 
            <PageHeader
              HeaderText="Tabs"
              Breadcrumb={[
                { name: "Home", navigate: "" },
                { name: "Machine Room Status", navigate: "" },
              ]}
              LastUpdatedDate={dashData1.lastUpdatedDateTime} 
              deviceSerial={currDeviceSerial}
              callback={deviceSerialChanged}
              />
            }
            <div className="row clearfix">
            <div className="col-lg-6 col-md-12">
                <div className="card">
                  <div className="header d-flex justify-content-between">
                    <h2>Machine Room Status</h2>
                    <div style={{display:"flex",gap:"10px"}}>
                      <button className={`btn ${graphMode === "Live" ? "btn-outline-success" : "btn-outline-primary"}`}   onClick={() => handleGraphModeChange('Live')} type="button">Live</button>
                      <button className={`btn ${graphMode === "Weekly" ? "btn-outline-success" : "btn-outline-primary"}`} onClick={() => handleGraphModeChange('Weekly')} type="button">Weekly</button>
                      <button className={`btn ${graphMode === "Days15" ? "btn-outline-success" : "btn-outline-primary"}`} onClick={() => handleGraphModeChange('Days15')} type="button">15-Days</button>
                      <button className={`btn ${graphMode === "Days30" ? "btn-outline-success" : "btn-outline-primary"}`} onClick={() => handleGraphModeChange('Days30')} type="button">Monthly</button>
                    </div>
                  </div>
                  <div className="body gender-overview" id="refreshDash1">
                    <h5>
                      <span className="m-r-20">
                        <strong style={{color:"blue",fontSize:"16px"}}>Heart Beat</strong> : {dashData1 && dashData1.currentBrakeTemp}
                      </span>
                      <span className="m-r-20">
                        <strong style={{color:"red",fontSize:"16px"}}>Motor Temp (°C)</strong> : {dashData1 && dashData1.currentMotorTemp}
                      </span>
                      <span className="m-r-20">
                        <strong style={{color:"green",fontSize:"16px"}}>MR Temp (°C)</strong> : {dashData1 && dashData1.currentMRBMETemp}
                      </span>
                    </h5>
                    <div id="m_area_chart" style={{ height: 300 }}></div>
                  </div>
                </div>
              </div>
              <div className="col-lg-6 col-md-12">
                <div className="card">
                  <div className="header d-flex justify-content-between">
                    <h2>Machine Room Pressure</h2>
                    <div style={{display:"flex",gap:"10px"}}>
                      <button className={`btn ${graphMode === "Live" ? "btn-outline-success" : "btn-outline-primary"}`}   onClick={() => handleGraphModeChange('Live')} type="button">Live</button>
                      <button className={`btn ${graphMode === "Weekly" ? "btn-outline-success" : "btn-outline-primary"}`} onClick={() => handleGraphModeChange('Weekly')} type="button">Weekly</button>
                      <button className={`btn ${graphMode === "Days15" ? "btn-outline-success" : "btn-outline-primary"}`} onClick={() => handleGraphModeChange('Days15')} type="button">15-Days</button>
                      <button className={`btn ${graphMode === "Days30" ? "btn-outline-success" : "btn-outline-primary"}`} onClick={() => handleGraphModeChange('Days30')} type="button">Monthly</button>
                    </div>
                  </div>
                  <div className="body gender-overview" id="refreshDash2">
                    <h5 style={{textAlign:"center"}}>
                      <span className="m-r-50">
                        <strong style={{color:"blue",fontSize:"16px"}}>Machine Room Pressure (hPa)</strong> : {dashData1 && dashData1.currentMRBmePerssure}
                      </span>
                    </h5>
                    <div id="m_area_chart2" style={{ height: 300 }}></div>
                  </div>
                </div>
              </div>
            </div>
            <div className="row clearfix">
              <div className="col-lg-6 col-md-12">
                <div className="card">
                <div className="header d-flex justify-content-between">
                    <h2>Machine Room Humidity</h2>
                    <div style={{display:"flex",gap:"10px"}}>
                      <button className={`btn ${graphMode === "Live" ? "btn-outline-success" : "btn-outline-primary"}`}   onClick={() => handleGraphModeChange('Live')} type="button">Live</button>
                      <button className={`btn ${graphMode === "Weekly" ? "btn-outline-success" : "btn-outline-primary"}`} onClick={() => handleGraphModeChange('Weekly')} type="button">Weekly</button>
                      <button className={`btn ${graphMode === "Days15" ? "btn-outline-success" : "btn-outline-primary"}`} onClick={() => handleGraphModeChange('Days15')} type="button">15-Days</button>
                      <button className={`btn ${graphMode === "Days30" ? "btn-outline-success" : "btn-outline-primary"}`} onClick={() => handleGraphModeChange('Days30')} type="button">Monthly</button>
                    </div>
                  </div>
                  <div className="body gender-overview" id="refreshDash3">
                     <h5 style={{textAlign:"center"}}>
                      <span className="m-r-50">
                        <strong style={{color:"blue",fontSize:"16px"}}>Machine Room Humidity (%)</strong> : {dashData1 && dashData1.currentMRBmeHumidity}
                      </span>
                    </h5>
                    <div id="m_area_chart3" style={{ height: 300 }}></div>
                  </div>
                </div>
              </div>
              <div className="col-lg-6 col-md-12">
                <div className="card">
                <div className="header d-flex justify-content-between">
                    <h2>Building Vibration</h2>
                    <div style={{display:"flex",gap:"10px"}}>
                      <button className={`btn ${graphMode === "Live" ? "btn-outline-success" : "btn-outline-primary"}`}   onClick={() => handleGraphModeChange('Live')} type="button">Live</button>
                      <button className={`btn ${graphMode === "Weekly" ? "btn-outline-success" : "btn-outline-primary"}`} onClick={() => handleGraphModeChange('Weekly')} type="button">Weekly</button>
                      <button className={`btn ${graphMode === "Days15" ? "btn-outline-success" : "btn-outline-primary"}`} onClick={() => handleGraphModeChange('Days15')} type="button">15-Days</button>
                      <button className={`btn ${graphMode === "Days30" ? "btn-outline-success" : "btn-outline-primary"}`} onClick={() => handleGraphModeChange('Days30')} type="button">Monthly</button>
                    </div>
                  </div>
                  <div className="body gender-overview" id="refreshDash4">
                    <h5 style={{textAlign:"center"}}>
                      <span className="m-r-50">
                        <strong style={{color:"blue",fontSize:"16px"}}>Building Vibration (Earthquake)</strong> : {dashData1 && dashData1.currentMRAdxlxyz}
                      </span>
                    </h5>
                    <div id="m_area_chart4" style={{ height: 300 }}></div>
                  </div>
                </div>
              </div>
            </div>            
            <div className="row clearfix">
              <div className="col-lg-6 col-md-12">
              {dashData1 && dashData1.lastUpdatedDateTime !== 'NA' &&
                <SwitchBordCard
                  Buttons={buttonsIndoor}
                  heading="Brake Status"
                />
              }
              {dashData1 && dashData1.lastUpdatedDateTime === 'NA'&& 
                <SwitchBordCard
                  Buttons={null}
                  heading="Brake Status"
                />
              }
              </div>
            </div>
          </div>
        </div>
      </div>
    );
}
